import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "",
    menus: [
      { href: "https://myflightzone.com.au/", label: "Home" },
      { href: "https://myflightzone.com.au/special-flights", label: "Special Flights" },
      { href: "https://myflightzone.com.au/who-we-are", label: "Who We Are" },
      { href: "https://myflightzone.com.au/blog", label: "Blog" },
    ],
  },
  {
    id: "1",
    title: "",
    menus: [
      { href: "https://myflightzone.com.au/terms-and-conditions", label: "Terms & Conditions" },
      { href: "https://myflightzone.com.au/privacy-policy", label: "Privacy Policy" },
      { href: "https://myflightzone.com.au/contact", label: "Contact" },
    ],
  },
  {
    id: "2",
    title: "",
    menus: [],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className=" space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const year = new Date().getFullYear();

  return (
    <div className="nc-Footer relative py-24 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
        </div>
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>

      <div className="container grid grid-cols-1 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-1 lg:grid-cols-1 lg:gap-x-10 ">
        <div className="text-center text-xs mt-10 ">
          &copy; {year} My Flight Zone All Rights Reserved.
        </div>
      </div>
      <div className="container grid grid-cols-1 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-1 lg:grid-cols-1 lg:gap-x-10 ">
        <div className="text-center text-xs mt-10 ">
          Created with <i className="la la-heart text-red-500"></i> by{" "}
          <a
            href="https://convergix.com.au/"
            target="_blank"
            title="Convergix"
            rel="noreferrer"
          >
            Convergix
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
